export class ResetCookieConsent {
  static readonly type = '[User] ResetCookieConsent';
}
